<template>
  <div class="audit-toolbar">
    <button class="audit-refresh-btn" @click="refreshData">&#x21BB; Refresh</button>
  </div>

  <div v-if="loading" class="audit-loading">Loading...</div>

  <div v-else-if="!changes.length" class="audit-empty">No changes recorded.</div>

  <div v-else class="audit-list">
    <div v-for="change in changes" :key="change.changeId" class="audit-card">
      <div class="audit-card-header">
        <span class="audit-date">{{ change.modifiedAt }}</span>
        <span class="audit-meta">{{ change.source }} &middot; {{ change.userName }}</span>
      </div>
      <div class="audit-card-body">
        <span class="audit-field">{{ change.propField }}</span>
        <div class="audit-values">
          <span class="audit-new">{{ change.newValue }}</span>
          <span class="audit-arrow">&#x2190;</span>
          <span class="audit-old">{{ change.previousValue }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['containerId', 'container'],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    changes() {
      const chg = this.$store.getters["changeTracking/getChangeTrackingByContainer"];
      if (!chg) return [];
      return chg.map(obj => ({
        ...obj,
        propField: obj.propertyName + obj.fieldName
      }));
    },
  },
  watch: {
    containerId() {
      this.loadData();
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    refreshData() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      if (this.container.containerId != null && this.container.containerId !== undefined && this.container.containerId > 0) {
        await Promise.all([
          this.$store.dispatch("changeTracking/loadChangeTrackingByContainer", this.container.containerId),
        ]);
      }
      this.loading = false;
    },
  }
};

</script>

<style scoped>
.audit-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 6px 0 10px;
}

.audit-refresh-btn {
  background: none;
  border: 1px solid #555;
  color: #ccc;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 0.8rem;
}
.audit-refresh-btn:hover {
  border-color: darkorange;
  color: darkorange;
}

.audit-loading,
.audit-empty {
  color: #888;
  font-size: 0.85rem;
  padding: 20px 0;
  text-align: center;
}

.audit-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 450px;
  overflow-y: auto;
  scrollbar-color: darkorange #303030;
  padding-right: 4px;
}

.audit-card {
  border: 1px solid #444;
  border-radius: 6px;
  padding: 10px 14px;
  background-color: #2a2a30;
}

.audit-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.audit-date {
  font-size: 0.75rem;
  color: #aaa;
}

.audit-meta {
  font-size: 0.75rem;
  color: darkorange;
}

.audit-card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.audit-field {
  font-size: 0.85rem;
  font-weight: 500;
  color: #ddd;
  min-width: 120px;
}

.audit-values {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
}

.audit-new {
  color: #7ecf7e;
}

.audit-arrow {
  color: #666;
}

.audit-old {
  color: #888;
  text-decoration: line-through;
}
</style>
